// Backend limits for scheduled tasks (gigawatt-backend validation).
export const SCHEDULED_TASK_PROMPT_MAX_LENGTH = 10000;
export const SCHEDULED_TASK_RECIPIENTS_MIN = 1;
export const SCHEDULED_TASK_RECIPIENTS_MAX = 10;

export const SCHEDULED_TASK_DATE_TIME_FORMAT: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
};

export const TaskRunOutcome = {
  Sent: 'sent',
  Skipped: 'skipped',
  Failed: 'failed',
} as const;

export type TaskRunOutcome =
  (typeof TaskRunOutcome)[keyof typeof TaskRunOutcome];

export const DisabledReason = {
  CreatorInactive: 'creator_inactive',
} as const;

export type DisabledReason =
  (typeof DisabledReason)[keyof typeof DisabledReason];

// Codes gigawatt-backend returns in the error body (GigawattErrorCode)
export const ScheduledTaskErrorCode = {
  InvalidCronExpression: 'invalid_cron_expression',
  InvalidTimezone: 'invalid_timezone',
  CadenceTooFrequent: 'cadence_too_frequent',
  InvalidRecipients: 'invalid_recipients',
  ScheduledTaskLimitExceeded: 'scheduled_task_limit_exceeded',
  ScheduledTaskNotFound: 'scheduled_task_not_found',
} as const;

export type ScheduledTaskErrorCode =
  (typeof ScheduledTaskErrorCode)[keyof typeof ScheduledTaskErrorCode];

// TODO: This should be generated by the backend library
export type TaskRunRecord = {
  started_at: string;
  outcome: TaskRunOutcome;
  reason: string | null;
  skipped_occurrences: number;
};

// TODO: This should be generated by the backend library
export type ScheduledTask = {
  organization_id: string;
  user_id: string;
  schedule_id: string;
  prompt: string;
  cadence: string;
  // IANA zone the cadence is read in (wall-clock time, so DST is followed)
  timezone: string;
  cadence_description: string;
  enabled: boolean;
  disabled_reason: DisabledReason | null;
  creator_email: string;
  // Employee ids; the backend resolves each to an email, and checks the employee
  // is still active, when the task runs.
  recipient_employee_ids: string[];
  created_at: string;
  last_run_at: string | null;
  next_due_at: string | null;
  // At most 10 entries, newest first
  run_history: TaskRunRecord[];
};

// TODO: This should be generated by the backend library
export type CreateScheduledTaskRequest = {
  prompt: string;
  cadence: string;
  // Backend defaults to UTC when omitted
  timezone?: string;
  cadence_description: string;
  // Backend defaults to the creator when omitted
  recipient_employee_ids?: string[];
};

// TODO: This should be generated by the backend library
// Partial update; the backend requires at least one field.
export type UpdateScheduledTaskRequest = Partial<
  CreateScheduledTaskRequest & { enabled: boolean }
>;
